module.exports = __webpack_public_path__ + "static/media/edit.26f0a964.png";